export default __webpack_public_path__ + "static/media/OfficeWorkersDraw.65de01be.svg";